module.exports = {
  GetShipments: require("./GetShipments"),
  QuickKey: require("./QuickKey"),
  ShipmentSorter: require("./ShipmentSorter/ShipmentSorter"),
  SearchShipments: require("./SearchShipments"),
  GetLocationCodeNames: require("./GetLocationCodeNames"),
  FilterShipments: require("./FilterShipments"),
};
